module.exports = __webpack_public_path__ + "static/item_m6_logo-d8ac86270cbc6af28b4e83098cd053fb.png";